@if (stoppedMovingSince || outOfBoundsSince || abnormalActivitySince) {
    <div>
        <div class="m-0 fw-bold">Alert status</div>
        @if (stoppedMovingSince) {
            <div class="mb-1">
                        <span><app-stopped-moving-svg
                                [height]="'30px'"
                                [width]="'30px'"
                                class="pointer img-fluid img-max m-auto"></app-stopped-moving-svg></span>
                <span class="color-danger p-1">Stopped moving {{ stoppedMovingSince | toRelativeTime }}</span>
            </div>
        }
        @if (outOfBoundsSince) {
            <div class="mb-1">
                        <span><app-oop-svg
                                [height]="'30px'"
                                [width]="'30px'"
                                class="pointer img-fluid img-max m-auto"></app-oop-svg></span>
                <span class="color-danger p-1">Out of paddock since {{ outOfBoundsSince | toRelativeTime }}</span>
            </div>
        }
        @if (abnormalActivitySince) {
            <div class="mb-1">
                        <span><app-abnormal-activity-svg
                                [height]="'30px'"
                                [width]="'30px'"
                                [high]="!!abnormalActivityIsHigh"
                                class="pointer img-fluid img-max m-auto"></app-abnormal-activity-svg></span>
                @if (abnormalActivityIsHigh) {
                    <span class="color-warning p-1">Abnormally high activity since {{ abnormalActivitySince | toRelativeTime }}</span>
                } @else {
                    <span class="color-danger p-1">Abnormally low activity since {{ abnormalActivitySince | toRelativeTime }}</span>
                }
            </div>
        }
        <hr/>
    </div>
}
